module.exports = __webpack_public_path__ + "static/media/mestre.a7b2b4b8.m4a";